import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHistory, Link, useLocation } from 'react-router-dom';
import { RootState } from 'reducers';
import { Globals } from 'utils';
import { ArrowLeft, LogoutIcon, MenuIcon } from 'assets/icons';
import { Logo } from 'assets/img';
import { menuItems, MenuItem } from './menu';

interface Props {
	className?: string;
	toggleSidebar?: any;
	toggleResponsive?: any;
}

const logout = (dispatch: any, history: any) => {
	Globals.confirm('¿Desea cerrar sesión?', () => {
		dispatch({ type: 'SET_USER', payload: null });
		history.replace('/login');
		Globals.quitLoading();
	});
}


const findMenuItem = (path: string, items: MenuItem[]): MenuItem | undefined => {
	for (const item of items) {
		if (item.submenu) {
			const found = findMenuItem(path, item.submenu);
			if (found) {
				return found;
			}
		}
		if (item.path === path) {
			return item;
		}
	}
	return undefined;
};

const Header = (props: Props) => {
	const header = useSelector((state: RootState) => state.header);
	const subheader = useSelector((state: RootState) => state.subheader);
	// const user = useSelector((state: RootState) => state.user);
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();

	let headerTitle = findMenuItem(location.pathname, menuItems)?.name;

	return (
		<div id="header" className={props.className}>
			<div className="container-blue-top">
				<button className="navbar-toggler responsive" type="button" onClick={() => props.toggleResponsive()}>
					<img src={MenuIcon} alt="" />
				</button>
				<div className="container-logo">
					<Link to="/">
						<img src={Logo} alt="" />
					</Link>
					<Link to="/" className="responsive">
						<img src={Logo} alt="" />
					</Link>
				</div>
				<div className="container-back-top">
					<button className="navbar-toggler" type="button" onClick={() => props.toggleSidebar()}>
						<img src={MenuIcon} alt="" />
					</button>
					{
						header.onBack && (
							<div className="arrow-back" onClick={header.onBack}>
								<img src={ArrowLeft} alt="" />
							</div>
						)
					}
					<div className="container-titles">
						<h3 className="title-top">{headerTitle ?? header.title}</h3>
						<h4 className="subtitle-top">{subheader.title}</h4>
					</div>
				</div>
				<div className="container-buttons-top">
					<div className="container-buttons-web">
						{/* <Link to="/profile">
							<button className={ `btn-profile ${ location.pathname === '/profile' ? 'active' : '' }` }>
								<span>{ user?.name }</span>
								<div className="container-settings">
									<img src={ UserSettings } alt="" />
								</div>
							</button>
						</Link> */}
						<button className="btn-logout" onClick={() => logout(dispatch, history)}>
							<img src={LogoutIcon} alt="" />
						</button>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Header;